import React, { Component } from 'react';

class Checkbox extends Component {
    render() {
        return (
            <div className="pp-input-wrapper pp-checkbox-wrapper">
                <label
                    className="pp-input-label"
                    htmlFor={this.props.htmlID}>
                        {this.props.label}
                </label>
                <input
                    type="checkbox"
                    checked={ this.props.checked }
                    id={this.props.htmlID}
                    className="pp-checkbox"
                    defaultValue={this.props.defaultValue}
                    disabled={this.props.disabled}
                />
            </div>
        );
    }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/Checkbox.js